import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

export enum StatusPillEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending',
  EXPIRED = 'expired',
}

const STATUS_LABELS: Record<StatusPillEnum, string> = {
  [StatusPillEnum.ACTIVE]: 'Ativo',
  [StatusPillEnum.INACTIVE]: 'Inativo',
  [StatusPillEnum.PENDING]: 'Pendente',
  [StatusPillEnum.EXPIRED]: 'Expirado',
};

const STATUS_CLASSES: Record<StatusPillEnum, string> = {
  [StatusPillEnum.ACTIVE]: 'bg-lSuccess text-lGray900 light:text-black/80',
  [StatusPillEnum.INACTIVE]: 'bg-lGray600 text-lWhite light:text-white',
  [StatusPillEnum.PENDING]: 'bg-lWarning text-lGray900 light:text-white',
  [StatusPillEnum.EXPIRED]: 'bg-lDanger text-white',
};

@Component({
  selector: 'l-status-pill',
  templateUrl: './status-pill.component.html',
  imports: [NgClass],
})
export class StatusPillComponent {

  @Input({ required: true })
  public status!: StatusPillEnum;

  public get label(): string {
    return STATUS_LABELS[this.status] ?? this.status;
  }

  public get cssClass(): string {
    return STATUS_CLASSES[this.status] ?? '';
  }
}
